/**
 * Site-wide content constants
 * For content that appears in multiple places but doesn't need CMS management
 */

// Promo/intro video shown on Home page and Help page
export const PROMO_VIDEO_ID = "605Bztdvsf8";
export const PROMO_VIDEO_URL = `https://youtu.be/${PROMO_VIDEO_ID}`;
export const PROMO_VIDEO_EMBED_URL = `https://www.youtube.com/embed/${PROMO_VIDEO_ID}`;
